import React from 'react'
import SearchBar from './SearchBar'

interface SearchBarContainerProps {
  onSearch?: (keyword: string) => void
  value?: string
}

function SearchBarContainer(props: SearchBarContainerProps) {
  const { onSearch, value } = props

  return <SearchBar onSearch={onSearch} value={value} />
}

export default SearchBarContainer
